module.exports = __webpack_public_path__ + "media/images/emblems/Finsterhennen-coat_of_arms-a257a02378b0a7f6bc8a9456b0ea7a73.svg";